/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type ColumnDef, Consts, I18nService, TimeService, UNPLACEHOLDER, UtilService } from '@dm/core';
import { type SelectOption } from '@dm/core/types';
import { MO } from 'app/common/constants/mo';

import { protectPeriodUnitE } from './create/config-policy/config-policy-str.service';

@Injectable({ providedIn: 'any' })
export class ScheduleStrService {
    table = {
        createBtn: this.get('common.create_button'),
        modifyBtn: this.get('common.modify_button'),
        deleteBtn: this.get('common.delete_button'),
        removeBtn: this.get('common.removeMember_button'),
        addBtn: this.get('common.addMember_button'),
        moreBtn: this.get('common.more_button'),
        activateBtn: this.get('common.enable_button'),
        deactivateBtn: this.get('common.disable0_label'),
        commaLab: this.get('common.comma_label'),
        nameCol: this.get('common.name_column'),
        statusCol: this.get('common.status_column'),
        numberOfPGCol: this.get('protection.HyperCDPSchedule_term_PGNumber_cloum'),
        numberOfLunCol: this.get('protection.HyperCDPSchedule_term_LunNumber_cloum'),
        numberOfFsCol: this.get('protection.HyperCDPSchedule_task_view_FSNumber_cloum'),
        executePolicyCol: this.get('protection.HyperCDPSchedule_term_executePolicy_cloum'),
        laskExecutionCol: this.get('protection.HyperCDPSchedule_term_lastExecuted_cloum'),
        laskExecutionResCol: this.get('protection.HyperCDPSchedule_term_lastExecutedResult_cloum'),
        hoursLab: this.get('common.timeAcount_hours_label'),
        minutesLab: this.get('common.timeAcount_minutes_label'),
        secondsLab: this.get('common.time_seconds_label'),

        previousBtn: this.get('common.previous_button'),
        nextBtn: this.get('common.next_button'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        confirmBtn: this.get('common.confirm_button'),
        actionBtn: this.get('common.operation_button'),
        closeBtn: this.get('common.close_button'),

        nameLab: this.get('common.name_column'),
        idLab: this.get('common.ID_column'),
        vstoreNameLab: this.get('vstore_name_lab'),
        vstoreAllLab: this.get('common.all_vstores_lab'),
        vstoreIdLab: this.get('vstore_id_lab'),
        wormCol: this.get('protection.HyperCDPSchedule_task_create_step2_secureSnap_lab'),
        autoDeleteCol: this.get('service.filesystem_task_create_worm_para_enableAutoDelete_checkbox'),
        valueSpace: (value): string => this.get('common.unit_value', [value]),
    };
    tip = {
        // "定时HyperCDP计划已禁用。",
        stopTip: this.get('protection.HyperCDPSchedule_term_task_disable_err_tip'),
        // 定时HyperCDP计划已启用。
        enableTip: this.get('protection.HyperCDPSchedule_term_task_enable_err_tip'),
        // 定时hyperCDP计划为已启用状态或保护组个数、LUN个数不同时为0。
        deleteTip: this.get('protection.HyperCDPSchedule_term_task_delete_err_tip'),
        // 定时hyperCDP计划为已启用状态或文件系统个数不同时为0。
        deleteTip2: this.get('protection.HyperCDPSchedule_term_fs_delete_err_tip'),
        // 定时hyperCDP计划无保护组或LUN。
        removeTip: this.get('protection.HyperCDPSchedule_term_task_removeMember_err_tip'),
        removeTip2: this.get('protection.HyperCDPSchedule_term_fs_removeMember_err_tip'),
        defaultCdpTip: this.get('protection.HyperCDPSchedule_task_delete_err_tip'),
    };
    title = {
        name: this.get('common.name_column'),
        status: this.get('common.status_column'),
        capacityLab: this.get('common.capacity_column'),
        runningStatusLab: this.get('common.runningStatus_column'),

        lun: this.get('common.lun_title'),
        pg: this.get('protection.protectionGroups_title'),
        fs: this.get('common.fileSystem_title'),
        lunType: this.get('common.objectType_LUN'),
        pgType: this.get('common.objectType_PG'),
        fsType: this.get('common.Filesystem_checkbox'),
        type: this.get('common.type_column'),
        modifySchedule: this.get('protection.protection_simplifiedMode_modifySnapPolicy_btn'),
    };
    promptTip = {
        deleteHyperCDPSchedule: this.get('protection.HyperCDPSchedule_task_delete_confirm_msg'),
        stopHyperCDPSchedule: this.get('protection.dataProtection_term_HyperCDPSchel_stop_msg'),
    };
    choose = {
        title: this.get('storage.lun_task_addToHyperCDPSchedule_tittle'),
        sourceLUN: this.get('common.sourceLun_label'),
        sourceFS: this.get('protection.fsSnap_term_view_sourceFilesystemName_column'),
        pgNameLabel: this.get('protection.protectionGroup_task_create_protectionGroup_lab'),
        addHyperPgPlaceholder: this.rangeByteLengthErr(1, 255),
        scheduleLabel: this.get('storage.lun_task_addToHyperCDPScheduley_HyperCDPSchedule_label'),
        createBtn: this.get('common.create_button'),
        avaiableLunLab: this.get('common.availableLun_column'),
        selectedLunLab: this.get('common.selectedLun_column'),
        avaiableFsLab: this.get('protection.HyperCDPSchedule_task_create_step1_availFS_lab'),
        selectedFsLab: this.get('protection.HyperCDPSchedule_task_create_step1_selectedFS_lab'),
        nameLab: this.get('common.name_column'),
        capacityLab: this.get('common.capacity_column'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        closeBtn: this.get('common.close_button'),
        selectedLuns: this.get('common.selectedLun_column'),
        selectedFs: this.get('protection.HyperCDPSchedule_task_create_step1_selectedFS_lab'),
        objectNotEnoughErr: this.get('common.selectOneObject_lab'),
        vStoreLab: this.get('common.owningVstore_lab'),
        vstoreIdLab: this.get('vstore_id_lab'),
        createPgResultName: (name): string => this.get('rest.createProtectionGroup_msg', [name]),
        addLunResultName: (lunName, scheduleName): string => this.get('rest.associateLun_toHyperCDPSchedule_msg', [lunName, scheduleName]),
        addFsResultName: (fsName, scheduleName): string => this.get('rest.associateFS_toHyperCDPSchedule_msg', [fsName, scheduleName]),
        addPgResultName: (pgName, scheduleName): string => this.get('rest.associatePG_toHyperCDPSchedule_msg', [pgName, scheduleName]),
    };

    render = {
        enable: (enabled: boolean | string): string => enabled === true || enabled === 'true' ?
            this.get('common.enabled_switch_column') :
            this.get('common.disabled_switch_column'),
        protectTime: (value, unit): string => this.table.valueSpace(value) + this.util.getLabelFromOptions(this.protectPeriodOptions, unit),
    };

    deleteMsg = this.get('protection.HyperCDPSchedule_task_delete_title');
    activateMsg = this.get('rest.startHyperCDPSchedule_msg');
    deactivateMsg = this.get('protection.HyperCDPSchedule_task_disable_title');
    deleteTitle = this.get('protection.HyperCDPSchedule_task_delete_title');

    brackets = this.get('common.brackets_connection_lab');
    typeOpt: SelectOption[] = [
        {
            label: this.title.pgType,
            value: MO.PROTECT_GROUP,
        },
        {
            label: this.title.lunType,
            value: MO.LUN,
        },
    ];
    memberObj: SelectOption[] = [
        {
            label: '',
            value: MO.PROTECT_GROUP,
        },
    ];
    scheduleStatusObj: SelectOption[] = [
        {
            label: this.get('common.service_enable_value'),
            value: '30',
        },
        {
            label: this.get('common.service_disable_value'),
            value: '31',
        },
        {
            label: this.get('common.EnumDefine_RUNNING_STATUS_E_INITIALIZING'),
            value: '53',
        },
        {
            label: this.get('common.EnumDefine_RUNNING_STATUS_E_REMOVING'),
            value: '106',
        },
        {
            label: this.get('common.EnumDefine_RUNNING_STATUS_E_STOPPING'),
            value: '111',
        },
    ];
    lastExecutionResObj: SelectOption[] = [
        {
            label: this.get('common.downloadsuccess_label'),
            value: '1',
        },
        {
            label: this.get('common.downloadFailed_label'),
            value: '2',
        },
        {
            label: UNPLACEHOLDER,
            value: '0',
        },
    ];

    runningStatusOpts: SelectOption[] = [
        {
            label: this.get('common.EnumDefine_RUNNING_STATUS_E_ONLINE'),
            value: '27',
        },
        {
            label: this.get('common.EnumDefine_RUNNING_STATUS_E_OFFLINE'),
            value: '28',
        },
    ];

    /**
     * WORM 开关
     */
    wormOptions: SelectOption[] = [
        {
            label: this.get('common.enabled_switch_column'),
            value: 'true',
        },
        {
            label: this.get('common.disabled_switch_column'),
            value: 'false',
        },
    ];

    /**
     * 自动删除
     */
    autoDeleteOptions: SelectOption[] = [
        {
            label: this.get('common.enabled_switch_column'),
            value: 'true',
        },
        {
            label: this.get('common.disabled_switch_column'),
            value: 'false',
        },
    ];

    /**
     * 最小保护期
     */
    protectPeriodOptions: SelectOption[] = [
        {
            label: this.get('common.lower_days_label'),
            value: protectPeriodUnitE.day,
        },
        {
            label: this.get('common.time_months_label'),
            value: protectPeriodUnitE.month,
        },
        {
            label: this.get('common.time_years_label'),
            value: protectPeriodUnitE.year,
        },
    ];

    filesystemColumnDefs: ColumnDef[] = [
        {
            field: 'NAME',
            header: this.title.name,
            filterType: 'search',
            sortable: true,
        },
        {
            field: 'ID',
            header: 'ID',
            width: '1rem',
            columnFilter: true,
        },
        {
            field: 'CAPACITY',
            header: this.title.capacityLab,
            align: 'right',
            columnFilter: true,
            hidden: true,
            render: (value): string => this.util.adaptUnit(value, Consts.SECTOR).label,
        },
    ];

    errorMsg = {};

    constructor(
        public util: UtilService,
        private i18nService: I18nService,
        private time: TimeService,
    ) { }

    deactivateRestMsg(params: string): string {
        return this.get('rest.stopHyperCDPSchedule_msg', [params]);
    }

    deleteRestMsg(params: string): string {
        return this.get('rest.delete_hyperCDPSchedule_msg', [params]);
    }

    get(key: string, params?: any[] | boolean, colon?: boolean): string {
        return this.i18nService.get(key, params, colon);
    }

    renderTime(time: string): string {
        return time === '0' || time === '18446744073709551615' || time === '-1' ?
            UNPLACEHOLDER :
            this.time.formatUTC(Number(time) * 1e3);
    }

    /**
     * 必填错误
     * @param name
     */
    requiredErr(name: string): string {
        return this.get('common.null_validation', [name]);
    }

    /**
     * 长度范围错误
     * @param min
     * @param max
     */
    rangeByteLengthErr(min: number, max: number): string {
        return this.get('common.length_msg', [min, max]);
    }

    /**
     * LUN名称
     * @param name
     */
    commonNameErr = (name: string): string => this.get('common.nameformat_validation', [name]);

    /**
     * 添加LUN到CDP计划
     * @param lunName
     * @param cdpScheduleName
     */
    addMemberLunMsg = (lunName: string, cdpScheduleName: string): string =>
        this.get('rest.associateLun_toHyperCDPSchedule_msg', [lunName, cdpScheduleName]);

    /**
     * 创建添加PG到CDP计划任务
     * @param pgName
     * @param cdpScheduleName
     */
    addMemberPgMsg = (pgName: string): string => this.get('protection.HyperCDPSchedule_term_addPG_createTask_result_lab', [pgName]);

    /**
     * 添加FS到CDP计划
     * @param fsName
     * @param cdpScheduleName
     */
    addMemberFsMsg = (fsName: string, cdpScheduleName: string): string =>
        this.get('rest.associateFS_toHyperCDPSchedule_msg', [fsName, cdpScheduleName]);

    /**
     * 移除LUN/PG
     * @param name
     */
    removeHyperCDPScheduleMember = (name: string): string =>
        this.get('protection.HyperCDPSchedule_task_removeMember_removeLunFromHyperCDPSchedule_msg', [name]);

    /**
     * 移除FS
     * @param name
     */
    removeHyperCDPScheduleFsMember = (name: string): string =>
        this.get('protection.HyperCDPSchedule_task_removeFSFromSchedule_confirm_msg', [name]);
}
